import { render, staticRenderFns } from "./customPopup.vue?vue&type=template&id=274e2aac&scoped=true"
import script from "./customPopup.vue?vue&type=script&lang=js"
export * from "./customPopup.vue?vue&type=script&lang=js"
import style0 from "./customPopup.vue?vue&type=style&index=0&id=274e2aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e2aac",
  null
  
)

export default component.exports